import { useAuth } from 'shared/hooks/useAuth';
import { GreetingHeader } from 'modules/jogador/player-home/components/GreetingHeader';
import { NextGameCard } from 'modules/jogador/player-home/components/NextGameCard';
import { ArenaList } from 'modules/jogador/player-home/components/ArenaList';
import { PillTabs } from 'shared/components/ui/PillTabs';
import { usePlayerHome } from 'modules/jogador/player-home/usePlayerHome';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { PlayerHomeSkeleton } from 'modules/jogador/player-home/components/PlayerHomeSkeleton';

export function PlayerHomePage() {
  const { user } = useAuth();
  const { sport, setSport, sports, nextGame, nearbyArenas, isLoading, error } = usePlayerHome();

  return (
    <section className="mx-auto max-w-2xl px-4 py-8">
      <GreetingHeader name={user?.name ?? ''} />

      <div className="mt-6">
        <PillTabs
          options={sports.map((label) => ({ value: label, label }))}
          value={sport}
          onChange={setSport}
        />
      </div>

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando sua home..."
        skeleton={
          <PlayerHomeSkeleton />
        }
      >
        {nextGame && (
          <div className="mt-6">
            <NextGameCard {...nextGame} />
          </div>
        )}

        <div className="mt-8">
          <ArenaList arenas={nearbyArenas} />
        </div>
      </AsyncSection>
    </section>
  );
}
